"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripStatsService = void 0;
class TripStatsService {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.resourceHostId = `myvw-trip-stats-service-${this.stage}`;
    }
    async getTripStatsData(props) {
        const queryParams = Object.entries(props)
            .filter(([key, value]) => key !== 'vin' && value !== undefined && key !== 'language')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const queryString = queryParams ? `?${queryParams}` : '';
        const url = `vehicles/${props.vin}/stats/${props.language}${queryString}`;
        const response = await this.authService.get(this.resourceHostId, url);
        if (!response.ok) {
            throw new Error((await response.json()).detail);
        }
        return response;
    }
}
exports.TripStatsService = TripStatsService;
//# sourceMappingURL=TripStatsService.js.map